declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../../services/spinner.service';
import { AppData } from '../../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveClinicalFormRequest } from '../../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../../models/actor/actor';
import { ActorService } from '../../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../../models/master/mastermodel';
import { FDService } from '../../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ngbaddforms',
  templateUrl: './addforms.modal.html',
  styleUrls: ['./addforms.modal.scss']
})

export class NgbAddFormsModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ActorCode;
    @Input() FormattedCode: string;
    @Input() PatientCode: number;
    @Input() IsShowDetail: boolean = false;
    public minDate: NgbDateStruct;
    public maxDate: NgbDateStruct;
    public Date: NgbDateStruct;
  //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
  @Input() ServiceCode: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  //public IsSelected: boolean;
    CurrentSaveClinicalFormRequest: SaveClinicalFormRequest;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private spinner: NgxSpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
      private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }
  ngOnInit() {
      this.CurrentSaveClinicalFormRequest = new SaveClinicalFormRequest();
    
      
      this.CurrentSaveClinicalFormRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowService = false;


    this.LoadRegistries();


  }




  LoadRegistries() {
    this.stopRefreshing();

    //this.GetBranchMap();

  }
    onAssignedToActorCodeForms(event: any) {
        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            // this.CurrentSaveFollicularPickupsDetailV2Request.Surgeon = event;
            //this.CurrentSaveFollicularPickupsDetailV2Request.SurgeonName = event;
            // console.log('event--_>' + event);
            //   }
            this.CurrentSaveClinicalFormRequest.FormName = event;
            //this.CurrentSaveClinicalFormRequest.FormCode
        }
    }
    onAssignedToActorCodesurgeon(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
           // this.CurrentSaveFollicularPickupsDetailV2Request.Surgeon = event;
            //this.CurrentSaveFollicularPickupsDetailV2Request.SurgeonName = event;
            // console.log('event--_>' + event);
            //   }
            //this.CurrentSaveClinicalFormRequest.Provider1Code = event;
            this.CurrentSaveClinicalFormRequest.Provider1Name = event;
        }

    }
    onAssignedToActorCodeAsstSurgeon(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            //this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon = event;
            //alert(this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeon);
            //this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeonName = event;
            // console.log('event--_>' + event);
            //   }
            //this.CurrentSaveClinicalFormRequest.Provider2Code = event;
            this.CurrentSaveClinicalFormRequest.Provider2Name = event;
        }

    }


  onSubmit() {
    this.spinner.show();
    this.StartRefreshing();
      //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
      this.CurrentSaveClinicalFormRequest.ConditionalOperator = 10;
      this.CurrentSaveClinicalFormRequest.FormattedCode = this.FormattedCode;
      this.CurrentSaveClinicalFormRequest.PatientCode = this.PatientCode;
      this.CurrentSaveClinicalFormRequest.UserName = AppData.Instance().UserLoginDetails.UserName;
      this.CurrentSaveClinicalFormRequest.Date = new Date(this.parserFormatter.format(this.Date));
      this.CurrentSaveClinicalFormRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
      //this.CurrentSaveClinicalFormRequest.PatientReportCode = 0;
    //this.CurrentActorAddEmergencyInfoRequest.AddressLine2 = "";
      this.actorservice.SaveClinicalForm(this.CurrentSaveClinicalFormRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.spinner.hide();
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            this.spinner.hide();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }





}
